import { ga } from 'mypages-library';

export const trackEvent = (eventParams: ga.EventParams) => {
  ga.trackEvent(eventParams);
};
